module.exports = __webpack_public_path__ + "static/media/location-new.f5c1ea7a.png";